var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinearScale = function SvgLinearScale(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.75 20.75v-8M15.75 20.75v-6M11.75 20.75v-8M7.75 20.75v-6M3.75 20.75v-8M19.75 5.75h-16M17.25 3.25l2.5 2.5-2.5 2.5M6.25 8.25l-2.5-2.5 2.5-2.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinearScale);
export default ForwardRef;